import BaseComponent from '../abstracts/BaseComponent';

const debug = false;

export default class SocialSharing extends BaseComponent {

  constructor(element) {
    super(element);

    debug && console.log('SocialSharing', this.$options);

    let shareData = {
      title: this.$options.title,
      url: this.$options.url,
    }
  
    const btn = this.$el.querySelector('button');
  
    const canShare = navigator.canShare;
    if (!canShare) {
      return;
    }

    this.$el.classList.add('navigator-can-share');

    btn.addEventListener('click', () => {
      navigator.share(shareData)
        .then(() => {
        })
        .catch((e) => {
        });
    });
  }
}
